import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

interface UseKeyboardShortcutsOptions {
  onEscape?: () => void;
  onCtrlK?: () => void;
  onEnter?: () => void;
  disabled?: boolean;
}

export const useKeyboardShortcuts = (options: UseKeyboardShortcutsOptions = {}) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (options.disabled) return;

    const handleKeyDown = (e: KeyboardEvent) => {
      // Ctrl+K or Cmd+K: Open chat
      if ((e.ctrlKey || e.metaKey) && e.key === 'k') {
        e.preventDefault();
        if (options.onCtrlK) {
          options.onCtrlK();
        } else {
          navigate('/chat');
        }
      }

      // Escape: Call custom handler
      if (e.key === 'Escape' && options.onEscape) {
        e.preventDefault();
        options.onEscape();
      }

      // Enter: Call custom handler (only if no input is focused)
      if (
        e.key === 'Enter' &&
        !e.shiftKey &&
        options.onEnter &&
        !(e.target instanceof HTMLTextAreaElement) &&
        !(e.target instanceof HTMLInputElement)
      ) {
        e.preventDefault();
        options.onEnter();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [navigate, options]);
};

export default useKeyboardShortcuts;
